
export function trackAddToCart() {
    try {
        fbq('track', 'AddToCart');
    } catch(e) {}
}
